import { render, staticRenderFns } from "./ScopeTitle.vue?vue&type=template&id=1193a04a"
import script from "./ScopeTitle.vue?vue&type=script&lang=js"
export * from "./ScopeTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports